"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareFavoriteMenuItemsRequest = prepareFavoriteMenuItemsRequest;
exports.prepareOrdersRequest = prepareOrdersRequest;
exports.transformAddCustomerAddressRequest = transformAddCustomerAddressRequest;
exports.transformAddFavoriteMenuItemRequest = transformAddFavoriteMenuItemRequest;
exports.transformCancelOrderRequest = transformCancelOrderRequest;
exports.transformEditFavoriteMenuItemRequest = transformEditFavoriteMenuItemRequest;
exports.transformGetMenuGroupRequest = transformGetMenuGroupRequest;
exports.transformLandingPageRequest = transformLandingPageRequest;
exports.transformNutritionalCalculationRequest = transformNutritionalCalculationRequest;
exports.transformPairKioskRequest = transformPairKioskRequest;
exports.transformPlaceOrderRequest = transformPlaceOrderRequest;
exports.transformPreviewOrderRequest = transformPreviewOrderRequest;
exports.transformRemoveCustomerAddressRequest = transformRemoveCustomerAddressRequest;
exports.transformRemoveFavoriteMenuItemRequest = transformRemoveFavoriteMenuItemRequest;
exports.transformReplaceOrderPreviewRequest = transformReplaceOrderPreviewRequest;
var orderUtils = _interopRequireWildcard(require("./orderUtils"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function transformPreviewOrderRequest(body) {
  return {
    body: orderUtils.preparePreviewOrderBody(body)
  };
}
function transformPlaceOrderRequest(body) {
  return {
    body: orderUtils.preparePlaceOrderBody(body)
  };
}
function transformReplaceOrderPreviewRequest(_ref) {
  let {
    orderId
  } = _ref;
  return {
    urlArgs: [orderId]
  };
}
function prepareOrdersRequest(_ref2) {
  let {
    page
  } = _ref2;
  return {
    searchParams: {
      page
    }
  };
}
function transformAddFavoriteMenuItemRequest(_ref3) {
  let {
    orderItem,
    name
  } = _ref3;
  return {
    body: orderUtils.prepareFavoriteMenuItemBody({
      orderItem,
      name
    })
  };
}
function prepareFavoriteMenuItemsRequest(_ref4) {
  let {
    page
  } = _ref4;
  return {
    searchParams: {
      page
    }
  };
}
function transformCancelOrderRequest(_ref5) {
  let {
    cancellationRemark,
    orderId
  } = _ref5;
  return {
    body: {
      cancellation_remark: cancellationRemark
    },
    urlArgs: [orderId]
  };
}
function transformEditFavoriteMenuItemRequest(_ref6) {
  let {
    name,
    id
  } = _ref6;
  return {
    body: {
      name
    },
    urlArgs: [id]
  };
}
function transformRemoveFavoriteMenuItemRequest(_ref7) {
  let {
    id
  } = _ref7;
  return {
    urlArgs: [id]
  };
}
function transformAddCustomerAddressRequest(_ref8) {
  let {
    address,
    postcode,
    coordinates,
    buildingName,
    streetName,
    floorUnit,
    deliveryInstruction,
    apiSettings
  } = _ref8;
  const coordinatesPoint = "POINT(".concat(coordinates.lng, " ").concat(coordinates.lat, ")");
  const {
    countryName,
    countryCodeAlpha3
  } = apiSettings;
  return {
    body: {
      address: [address, countryName, countryCodeAlpha3].join(", "),
      postcode,
      floor_unit: floorUnit || null,
      building: buildingName || null,
      delivery_instructions: deliveryInstruction || null,
      coordinates: coordinatesPoint,
      street_name: streetName || null
    }
  };
}
function transformRemoveCustomerAddressRequest(_ref9) {
  let {
    customerAddressId
  } = _ref9;
  return {
    urlArgs: [customerAddressId]
  };
}
function transformLandingPageRequest(_ref10) {
  let {
    landingPageSlug
  } = _ref10;
  return {
    urlArgs: [landingPageSlug]
  };
}
function transformGetMenuGroupRequest(_ref11) {
  let {
    menuGroupId
  } = _ref11;
  return {
    urlArgs: [menuGroupId]
  };
}
function transformNutritionalCalculationRequest(_ref12) {
  let {
    ingredientServings,
    baseType
  } = _ref12;
  return {
    body: {
      check_max_items: false,
      base_type_id: baseType,
      ingredients: Object.keys(ingredientServings).map(key => ({
        id: key,
        servings: ingredientServings[key]
      }))
    }
  };
}
function transformPairKioskRequest(_ref13) {
  let {
    code
  } = _ref13;
  return {
    body: {
      code
    }
  };
}